module.exports = __webpack_public_path__ + "img/equipo-gaming-elite-avanzado-procesador.edcc00f4.jpg";